/**
 * Preferenza «tabelle compatte» (ADR 0030 §7): righe più basse nelle tabelle.
 *
 * Vale per il browser, come tema e lingua: si salva in `localStorage` e si
 * legge in modo sincrono all'avvio. L'accesso allo storage può sollevare
 * (navigazione privata, storage bloccato), quindi ogni lettura e scrittura sta
 * in un `try/catch` e un errore fa ricadere sul valore predefinito.
 */

/** Chiave della preferenza nello storage del browser. */
export const COMPACT_TABLES_KEY = 'institor.compactTables';

/** Padding verticale delle celle con le tabelle compatte, in pixel. */
export const COMPACT_CELL_PADDING_BLOCK = 2;

/**
 * Legge la preferenza salvata.
 *
 * @returns True se l'utente ha scelto le tabelle compatte.
 */
export function readCompactTables(): boolean {
  try {
    return window.localStorage.getItem(COMPACT_TABLES_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Ricorda la preferenza per le visite successive.
 *
 * @param compact True per le tabelle compatte.
 */
export function storeCompactTables(compact: boolean): void {
  try {
    window.localStorage.setItem(COMPACT_TABLES_KEY, compact ? '1' : '0');
  } catch {
    // Storage negato: la scelta vale fino al ricaricamento della pagina.
  }
}
